import { useEffect, useState, useContext } from 'react'
import { useHistory } from 'react-router-dom'
import ResponsiveLayout from 'containers/Layouts/ResponsiveLayout'
import {
    Grid, Card, CardHeader, CardContent, Typography, Avatar, Divider, CardActions, Button, Paper, Link
} from '@material-ui/core'
import { ArrowDownward, ArrowLeft, ArrowLeftOutlined } from '@material-ui/icons'
import { StateContext, DispatchContext } from 'context/Provider';

import Moment from 'moment'
import axios from 'axios'

import './style.css'

const ViewMessage = (props) => {
    const appState = useContext(StateContext)
    const { authState } = appState

    const appDispatch = useContext(DispatchContext)
    const { globalDispatch } = appDispatch
    const history = useHistory()

    const [message, setMessage] = useState(null)
    let messageId = props.computedMatch.params.messageid

    const getMessage = async () => {
        const axiosInstance = axios.create({
            baseURL: 'https://sms.academeportal.com/api/'
        });

        const response = await axiosInstance.get(`messages/${authState.user.id}/${messageId}`)
        setMessage(response.data)

        globalDispatch({type: 'setIsLoading', value: false});
    }

    const diffForHumans = (date) => {
        let momentDdate = Moment(date)
        let relativeTime = momentDdate.startOf('hour').fromNow()
        if (relativeTime.includes('minutes ago' || relativeTime.includes('hours')) || relativeTime.includes('hour')) {
            return relativeTime
        }

        return momentDdate.format('MMMM D, YYYY hh:mm a')
    }

    useEffect(() => {
        globalDispatch({type: 'setIsLoading', value: true});
        getMessage()
    }, [messageId])

    return (
        <ResponsiveLayout>
            <Grid container justify='center'>
                <Grid item xs={12} sm={12} md={8} lg={6} xl={6}>
                    <Link className="see-all-messages-btn" onClick={() => history.push('/message/all')}>
                        <Button variant="outlined" startIcon={<ArrowLeftOutlined/>}>
                            <Typography>See all messages</Typography>
                        </Button>
                    </Link>
                    {
                        message != null &&
                        message.data.conversation.length > 0 &&
                        message.data.conversation.map((msg) => (
                            <Card style={{marginBottom: '10px'}}>
                                <CardHeader
                                    avatar={<Avatar alt={msg.sender.name} src='/unknow/path'/>}
                                    title={
                                        <Typography variant='body1' component='h2' style={{fontWeight: 'bold'}}>{msg.sender.name}</Typography>
                                    }
                                    subheader={
                                        <Typography varitn='body2' component='p'>{diffForHumans(msg.created_at)}</Typography>
                                    }
                                />
                                <Divider />
                                <CardContent>
                                    <Typography variant='h6' component='h2'>{msg.subject}</Typography>
                                    <Typography dangerouslySetInnerHTML={{__html: msg.body}} />
                                </CardContent>
                                { msg.attachement_url !== null && <CardActions>
                                    <a href={msg.attachement_url} target="_blank" rel="noreferrer" style={{textDecoration: 'none'}}>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            size="small"
                                            startIcon={<ArrowDownward/>}
                                        >
                                            Download Attachment
                                        </Button>
                                    </a>
                                </CardActions> }
                            </Card>
                        ))
                    }
                </Grid>
            </Grid>
        </ResponsiveLayout>
    )
}

export default ViewMessage